import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  smallIcon: {
    fontSize: '0.5em',
  },
}));
